import { AppText } from "@/components/AppText";
import { Button } from "@/components/Button";
import { Input } from "@/components/Input";
import { showError, showSuccess } from "@/utils/toast";
import { router } from "expo-router";
import React, { useEffect, useState } from "react";
import { ScrollView, TouchableOpacity, View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { SafeAreaView } from "react-native-safe-area-context";
import { Ionicons } from "@expo/vector-icons";
import AuthServices from "@/services/authServices";
import FBTrackingService from "@/services/fbTrackingService";

export default function ForgotPasswordScreen() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    FBTrackingService.trackViewContent("forgot-password");
  }, []);

  const handleResetPassword = async () => {
    if (!email) {
      showError("Please enter your email address", "Validation Error");
      return;
    }

    setIsLoading(true);

    try {
      const response = await AuthServices.forgotPassword(email);
      if (response.success) {
        showSuccess(
          "Follow the link we sent to your email to reset your password",
          "Success"
        );
        router.back();
      } else {
        showError("An unexpected error occurred", "Error");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      showError("An unexpected error occurred", "Error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      {/* Back Button */}
      <View style={styles.backButton}>
        <TouchableOpacity onPress={() => router.back()}>
          <Ionicons name="chevron-back" size={24} color="#000" />
        </TouchableOpacity>
      </View>

      <View style={styles.content}>
        <ScrollView
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={false}
        >
          {/* Forgot Password Form */}
          <View style={styles.form}>
            <AppText style={styles.title}>Forgot password</AppText>

            <Input
              placeholder="Email"
              value={email}
              onChangeText={setEmail}
              keyboardType="email-address"
              autoCapitalize="none"
              autoComplete="email"
              editable={!isLoading}
            />

            <Button
              title={isLoading ? "Sending..." : "Submit"}
              onPress={handleResetPassword}
              style={[styles.loginButton, isLoading && styles.disabledButton]}
              disabled={isLoading}
            />
          </View>
        </ScrollView>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  backButton: {
    paddingHorizontal: 20,
    paddingTop: 8,
    paddingBottom: 16,
  },
  content: {
    flex: 1,
    paddingHorizontal: 20,
  },
  scrollContent: {
    flexGrow: 1,
    paddingTop: 16,
  },
  form: {},
  title: {
    fontSize: 32,
    fontWeight: "600",
    lineHeight: 40,
    color: "#000",
    marginBottom: 32,
  },
  loginButton: {
    marginTop: 8,
    marginBottom: 24,
    backgroundColor: "#0F9129",
    borderRadius: 8,
    height: 56,
  },
  disabledButton: {
    opacity: 0.6,
  },
});
